import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { authProtectedRoutes } from "../../routes";
import { Loader } from "../../components/Loader";
import { Page500 } from "../../components/Utility";
import { getMe } from "../../store/actions";
import { APP_ROUTES } from "helpers/routeHelpers";

const DefaultLayout = ({ Layout }) => {
    let dispatch = useDispatch();
    const { tokenVerified, isLoading } = useSelector((state) => state.root);
    const { isAuthenticated } = useSelector((state) => state.userAuth);

    const Role = useSelector((state) => state?.userAuth?.user?.Type);

    useEffect(() => {
        if (isAuthenticated) {
            if (!tokenVerified) {
                dispatch(getMe()).catch(() => {});
            }
        }
    }, []);

    if (!isAuthenticated) {
        // return <Redirect to={APP_ROUTES.LOGIN} />;
        window.location.replace(APP_ROUTES.LOGIN);

    }

    // :TODO: Need to change this, right now its just to execute the project
    const roleBasedRoutes = authProtectedRoutes.filter((item) => !item.permissions?.includes(Role));

    return tokenVerified ? (
        <Switch>
            {authProtectedRoutes.map((route, index) => {
                return (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => (
                            <Layout>
                                <route.component {...props} />
                            </Layout>
                        )}
                    />
                ); 
            })}

            <Redirect to={APP_ROUTES.BLS_FEEDBACK} />
        </Switch>
    ) : !tokenVerified && isLoading ? (
        <Loader classes="vh-100" showVerifyText={true} />
    ) : // <Page500 />
    null;
};

export default DefaultLayout;
